import { render } from "./doughnut-chart.vue?vue&type=template&id=27c4078c"
import script from "./doughnut-chart.vue?vue&type=script&lang=js"
export * from "./doughnut-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/charts/doughnut-chart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27c4078c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27c4078c', __exports__)) {
    api.reload('27c4078c', __exports__)
  }
  
  module.hot.accept("./doughnut-chart.vue?vue&type=template&id=27c4078c", () => {
    api.rerender('27c4078c', render)
  })

}


export default __exports__